import { Component, OnInit } from '@angular/core';
import { EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EditEcowasBusinessConfigTableComponent } from '../Table/edit-ecowas-business-config-table/edit-ecowas-business-config-table.component';
import { EditEcowasWhitelistConfigTableComponent } from '../Table/edit-ecowas-whitelist-config-table/edit-ecowas-whitelist-config-table.component';
import { EditEcowasConfigTableComponent } from '../Table/edit-ecowas-config-table/edit-ecowas-config-table.component';
import { ViewEcowasBusinessConfigTableComponent } from '../view-ecowas-business-config-table/view-ecowas-business-config-table.component';
import { ViewEcowasConfigTableComponent } from '../view-ecowas-config-table/view-ecowas-config-table.component';
import { ViewEcowasWhitelistConfigTableComponent } from '../view-ecowas-whitelist-config-table/view-ecowas-whitelist-config-table.component';
import { ViewEcowasOrganizationTableComponent } from '../view-ecowas-organization-table/view-ecowas-organization-table.component';
import { ViewEcowasInConfigTableComponent } from '../view-ecowas-in-config-table/view-ecowas-in-config-table.component';
import { ViewProbeConfigTableComponent } from '../view-probe-config-table/view-probe-config-table.component';
import { EditEcowasProbeConfigTableComponent } from '../Table/edit-ecowas-probe-config-table/edit-ecowas-probe-config-table.component';
import { EditEcowasOrganizationConfigTableComponent } from '../Table/edit-ecowas-organization-config-table/edit-ecowas-organization-config-table.component';
import { EditEcowasInConfigTableComponent } from '../Table/edit-ecowas-in-config-table/edit-ecowas-in-config-table.component';
// import { EditRrmsServiceLiveComponent } from '../edit-rrms-service-live/edit-rrms-service-live.component';
// import { ViewServiceLiveComponent } from '../view-service-live/view-service-live.component';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { DeleteRrmsServiceLiveDataComponent } from '../delete-rrms-service-live-data/delete-rrms-service-live-data.component';
import { EditEcowasAllowedGtComponent } from '../Table/edit-ecowas-allowed-gt/edit-ecowas-allowed-gt.component';
import { EditEcowasCcNdcComponent } from '../Table/edit-ecowas-cc-ndc/edit-ecowas-cc-ndc.component';
import { EditEcowasMccMncComponent } from '../Table/edit-ecowas-mcc-mnc/edit-ecowas-mcc-mnc.component';
import { EditEcowasinEcowasThresholdConfigComponent } from '../Table/edit-ecowasin-ecowas-threshold-config/edit-ecowasin-ecowas-threshold-config.component';
import { EditRrmsProbedbAllowedGtComponent } from '../Table/edit-rrms-probedb-allowed-gt/edit-rrms-probedb-allowed-gt.component';
import { EditRrmsProbedbCcNdcComponent } from '../Table/edit-rrms-probedb-cc-ndc/edit-rrms-probedb-cc-ndc.component';
import { EditRrmsProbedbMccMncComponent } from '../Table/edit-rrms-probedb-mcc-mnc/edit-rrms-probedb-mcc-mnc.component';
import { EditRrmsProbedbEcowasOrganizationComponent } from '../Table/edit-rrms-probedb-ecowas-organization/edit-rrms-probedb-ecowas-organization.component';
import { ViewProbAllowedGtComponent } from '../view-prob-allowed-gt/view-prob-allowed-gt.component';
import { ViewAllowedGtComponent } from '../view-allowed-gt/view-allowed-gt.component';

@Component({
  selector: 'app-rrms-service-live-data-table',
  templateUrl: './rrms-service-live-data-table.component.html',
  styleUrls: ['./rrms-service-live-data-table.component.scss']
})
export class RrmsServiceLiveDataTableComponent implements OnInit {

  @Input() tableData: any;

   businessConfigData:any=[]
  ecowasConfigdata:any=[]
  whitelistConfigData=[]
  probeconfigData=[]
  organizationConfig=[]
  ecowasIn=[]
  storetabledata:any;
  orgIds:any
  constructor(private dialog: MatDialog, private endpointsService:EndpointsService,
              private backendApiService:BackendApiService, private spinnerservice:Ng4LoadingSpinnerService) { }

  ngOnInit(): void {
    // this.spinnerservice.show();
//     console.log(">>>>",JSON.stringify(this.tableData))
//     for (var i = 0; i <= this.tableData.length ; i++){
//       console.log("???",JSON.stringify(this.tableData))
//     }
// this.storetabledata = JSON.stringify(this.tableData)
// console.log('this.storetabledata',this.storetabledata)
// this.orgIds = this.tableData.map(item => item.orgId);
//     console.log('tabb',this.orgIds)
   // this.getApiData();
  }
 
  async getApiData(){
  //   let apiUrl = this.endpointsService.URL_GET_BUSINESS_CONFIG +
  //   '&orgId=' + '274';
 
  // this.backendApiService.callToApi(apiUrl).subscribe(response => {
  //   this.businessConfigData = response;
  //   console.log("respone",response)
  // });
  // this.businessConfigData = await this.backendApiService.callToApi(this.endpointsService.URL_GET_BUSINESS_CONFIG + '&orgId=' + '')
  // .toPromise();
  // console.log('this.businessConfigData',this.businessConfigData)
 
  // this.ecowasConfigdata = await this.backendApiService.callToApi(this.endpointsService.URL_GET_ECOWAS_CONFIG + '&orgId=' +  '')
  // .toPromise();
  // console.log('this.ecowasConfigdata',this.ecowasConfigdata)
  
  // this.whitelistConfigData = await this.backendApiService.callToApi(this.endpointsService.URL_GET_ECOWAS_WHITELIST_CONFIG + '&orgId=' +  '')
  // .toPromise();
  // console.log('this.ecowasConfigdata',this.whitelistConfigData)

  // this.probeconfigData = await this.backendApiService.callToApi(this.endpointsService.URL_GET_PROBE_CONFIG + '&orgId=' +  '')
  // .toPromise();
  // console.log('this.ecowasConfigdata',this.probeconfigData)

  // this.organizationConfig = await this.backendApiService.callToApi(this.endpointsService.URL_GET_ECOWAS_ORGANIZATION_CONFIG + '&orgId=' +  '')
  // .toPromise();
  // console.log('this.ecowasConfigdata',this.organizationConfig)

  // this.ecowasIn = await this.backendApiService.callToApi(this.endpointsService.URL_GET_ECOWAS_IN + '&orgId=' +  '')
  // .toPromise();
  // console.log('this.ecowasConfigdata',this.ecowasIn)
  
  }
  businessUpdateClick(row:any){
    console.log("row",row)
    console.log("data",this.businessConfigData)
    const dialogRef = this.dialog.open(EditEcowasBusinessConfigTableComponent, {
      width:'1500px',
      data: {rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result,'1111')
      if(result === true){
        
       // this.refreshTableData.emit();
      }
      
    });
  }
 
  configUpdateClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasConfigTableComponent, {
      width:'1500px',
      data: { rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    
  }
  organizationConfigUpdateClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasOrganizationConfigTableComponent, {
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    
  }
  probeConfigUpdateClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasProbeConfigTableComponent, {
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    
  }
 
  ecowasInConfigClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasInConfigTableComponent, {
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    
  }
  // ecowasAllowedGt(row:any){
  //   console.log("row",row)
  //   const dialogRef = this.dialog.open(EditEcowasAllowedGtComponent,{
  //     width:'1500px',
  //     data:{rowData:row},
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
  //   });
  // }
  ecowasCcNdcClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasCcNdcComponent,{
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
  ecowasMncMccClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasMccMncComponent,{
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
  ecowasThresholdConfigClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasinEcowasThresholdConfigComponent,{
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
  // probDbAllowedGt(row:any){
  //   const dialogRef = this.dialog.open(EditRrmsProbedbAllowedGtComponent,{
  //     width:'1500px',
  //     data:{rowData:row},
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
  //   });
  // }
  viewProbAllowGt(row:any){
    console.log("row",row)
       const dialogRef = this.dialog.open(ViewProbAllowedGtComponent,{
      width:'1500px',
      height:'500px',
      data:{rowData:row,cameFrom:'rrms'},
      panelClass: 'custom-modalbox',
      disableClose: true
    });

  }
  viewAllowedGt(row:any){
    console.log("row",row)
    const dialogRef = this.dialog.open(ViewAllowedGtComponent,{
   width:'1500px',
   height:'500px',
   data:{rowData:row,cameFrom:'rrms'},
   panelClass: 'custom-modalbox',
   disableClose: true
 });
  }
  probDbCcNdc(row:any){
    const dialogRef = this.dialog.open(EditRrmsProbedbCcNdcComponent,{
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
  probDbMccMnc(row:any){
    const dialogRef = this.dialog.open(EditRrmsProbedbMccMncComponent,{
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
probDbOrganizationClick(row:any){
  const dialogRef = this.dialog.open(EditRrmsProbedbEcowasOrganizationComponent,{
    width:'1500px',
    data:{rowData:row},
    panelClass: 'custom-modalbox',
    disableClose: true
  });
}


  

 
  viewWhitelistClick(row:any){
    console.log("row",row)
    const dialogRef = this.dialog.open(ViewEcowasWhitelistConfigTableComponent, {
      width:'1500px',
      height:'500px',
      data: {rowData:row,cameFrom:'rrms' },
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    
  }
   // whitelistUpdateClick(){
  //   const dialogRef = this.dialog.open(EditEcowasWhitelistConfigTableComponent, {
  //     width:'900px',
  //     data: { whitelistData: this.whitelistConfigData},
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
   
  // }
   // viewbusinessClick(){
  //   console.log("dddd",this.businessConfigData)
  //   const dialogRef = this.dialog.open(ViewEcowasBusinessConfigTableComponent, {
  //     width:'1500px',
  //     height:'500px',
  //     data: { businessData: this.businessConfigData},
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
    
  // }
  // viewConfigClick(){
  //   const dialogRef = this.dialog.open(ViewEcowasConfigTableComponent, {
  //     width:'1500px',
  //     height:'500px',
  //     data: { ecowasData: this.ecowasConfigdata},
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
    
  // }
  // viewProbeConfigClick(){
  //   const dialogRef = this.dialog.open(ViewProbeConfigTableComponent, {
  //     width:'1500px',
  //     height:'500px',
     
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
    
  // }
  // viewEcoshowInClick(){
  //   const dialogRef = this.dialog.open(ViewEcowasInConfigTableComponent, {
  //     width:'1500px',
  //     height:'500px',
     
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
    
  // }
  // viewEcowasOrganization(){
  //   const dialogRef = this.dialog.open(ViewEcowasOrganizationTableComponent, {
  //     width:'1500px',
  //     height:'500px',
      
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
    
  // }
  deleteRrmsConfig(row:any){
    const dialogRef = this.dialog.open(DeleteRrmsServiceLiveDataComponent, {
          width:'500px',
         
          data:{rowData:row},
          panelClass: 'custom-modalbox',
          disableClose: true
          
        });
  }
}
